import { defaultTo, map, orderBy } from 'lodash';
import {
  IModel,
  Model,
  ModelRecord,
  PhotoModel,
  QuestionListValueModel,
  QuestionSpeciesModel,
  QuestionStateModel,
  QuestionTypeModel,
} from '@common/models';

export interface IQuestionModel extends IModel {
  questionId: number;
  sectionId: number;
  questionTypeId: number;
  questionType: QuestionTypeModel | undefined;
  name: string;
  followupQuestion: string;
  showFollowupWhenAnswerIs: boolean | undefined;
  allowMultiple: boolean | undefined;
  isReadOnly: boolean | undefined;
  defaultValue: string;
  sortOrder: number;
  photoId?: number | undefined;
  photo: PhotoModel | undefined;
  yesOverrideText: string;
  noOverrideText: string;
  useMultiChoiceDropDown: boolean | undefined;
  isFollowupReadOnly: boolean | undefined;
  isActive: boolean;
  questionListValues: QuestionListValueModel[];
  species: QuestionSpeciesModel[];
  states: QuestionStateModel[];
}

export class QuestionModel
  extends Model
  implements ModelRecord<IQuestionModel>
{
  questionId: number;
  sectionId: number;
  questionTypeId: number;
  questionType: QuestionTypeModel | undefined;
  name: string;
  followupQuestion: string;
  showFollowupWhenAnswerIs: boolean | undefined;
  allowMultiple: boolean | undefined;
  isReadOnly: boolean | undefined;
  defaultValue: string;
  sortOrder: number;
  photoId: number | undefined;
  photo: PhotoModel | undefined;
  yesOverrideText: string;
  noOverrideText: string;
  useMultiChoiceDropDown: boolean | undefined;
  isFollowupReadOnly: boolean | undefined;
  isActive: boolean;
  questionListValues: QuestionListValueModel[] = [];
  species: QuestionSpeciesModel[] = [];
  states: QuestionStateModel[] = [];

  constructor(params?: Partial<IQuestionModel>) {
    super(params);
    this.questionId = defaultTo(params?.questionId, 0);
    this.sectionId = defaultTo(params?.sectionId, 0);
    this.name = defaultTo(params?.name, '');
    this.questionTypeId = defaultTo(params?.questionTypeId, 0);
    this.questionType = params?.questionType
      ? new QuestionTypeModel(params?.questionType)
      : undefined;
    this.followupQuestion = defaultTo(params?.followupQuestion, '');
    this.showFollowupWhenAnswerIs = defaultTo(
      params?.showFollowupWhenAnswerIs,
      false,
    );
    this.allowMultiple = defaultTo(params?.allowMultiple, false);
    this.isReadOnly = defaultTo(params?.isReadOnly, false);
    this.defaultValue = defaultTo(params?.defaultValue, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.photoId = defaultTo(params?.photoId, undefined);
    this.photo = params?.photo ? new PhotoModel(params?.photo) : undefined;
    this.yesOverrideText = defaultTo(params?.yesOverrideText, '');
    this.noOverrideText = defaultTo(params?.noOverrideText, '');
    this.useMultiChoiceDropDown = defaultTo(
      params?.useMultiChoiceDropDown,
      false,
    );
    this.isFollowupReadOnly = defaultTo(params?.isFollowupReadOnly, false);
    this.isActive = defaultTo(params?.isActive, false);
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    map(
      orderBy(params?.questionListValues, (v) => v.sortOrder),
      (qlv) => {
        this.questionListValues.push(new QuestionListValueModel(qlv));
      },
    );
    map(params?.species, (s) => {
      this.species.push(new QuestionSpeciesModel(s));
    });
    map(params?.states, (s) => {
      this.states.push(new QuestionStateModel(s));
    });
  }
}
